import { ref, computed } from 'vue'
import { defineStore } from 'pinia'
import axios from "axios";
import ApiHelper from "@/helpers/apiHelper.ts";
import authService from "@/services/authService.ts";

    export const useLaureateStore = defineStore('laureate',  {
    state: () => ({
        laureateInfo: {},
        isLoading: false,
        status: null,
        errorMessage: ''
    }),
    actions: {
        async getLaureateInfo() {
            try {
                this.isLoading = true;
                const token = await (new authService()).getToken();
                const response = await axios.get(ApiHelper.getLaureateInfoUrl(), {
                    headers: {'X-Form-Token': token}
                });
                this.laureateInfo = response.data?.data || {};
                this.errorMessage = response.data?.message || {};
                this.isLoading = false;
            } catch (error: any) {
                console.error("Error fetching form information:", error);
                if(error.status === 404) {
                    this.errorMessage = 'Błędny adres formularza'
                }
                this.isLoading = false;
            }
        }
    }
})
